import { atom } from "recoil";
export const SendMessageFlag = atom({
    key: "SendMessageFlag", // unique ID (with respect to other atoms/selectors)
    default: false, // default value (aka initial value)
});
